const Loading = ({ loadingMessage }) => {
  return <div className="fixed top-0 left-0 w-full h-full bg-white z-50 flex items-center justify-center opacity-95">
    <div className="">
      <div className="flex justify-center">
        <img className="w-24" src="/image/loading_book.gif" />
      </div>
      {
        loadingMessage && <div className="text-sm font-bold w-52 text-center whitespace-pre-wrap">
          {loadingMessage}
        </div>
      }
      <div>

      </div>
    </div>
  </div>
}

export default Loading;